import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit, ChangeDetectorRef, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appLazyLoadImage]'
})

export class LazyLoadImageDirective implements OnInit, OnChanges {
    @Input() appLazyLoadImage: string;
    private observer: IntersectionObserver | undefined;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private cdRef: ChangeDetectorRef,
    ) { }

    ngOnInit(): void {
        this.setupLazyLoad();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['appLazyLoadImage'] && !changes['appLazyLoadImage'].firstChange) {
            this.loadImage();
        }
    }

    private setupLazyLoad(): void {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.loadImage();
                    this.observer?.unobserve(entry.target);
                }
            });
        }, options);

        this.observer.observe(this.el.nativeElement);
    }

    private loadImage(): void {
        const imgElement = this.el.nativeElement as HTMLImageElement;
        if (this.appLazyLoadImage) {
            this.renderer.setAttribute(imgElement, 'src', this.appLazyLoadImage as string);
            this.cdRef.detectChanges();
        }
    }
}